import { render, staticRenderFns } from "./RelocateLink.vue?vue&type=template&id=6a23fa28"
import script from "./RelocateLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelocateLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports